import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';

import { OPU_SEARCH_COMMENT_OPTIONS } from '../../utils/constants';
import { OpuSearchFormValues } from '../../utils/schema';

interface Props {
  control: Control<OpuSearchFormValues>;
  comments: string;
  setValue: UseFormSetValue<OpuSearchFormValues>;
}

export const OpuSearchFormComments = ({
  control,
  comments,
  setValue,
}: Props) => (
  <section
    style={{ backgroundColor: 'var(--color-background)' }}
    className="rounded border border-slate-300 p-1 text-[11px]"
  >
    <label htmlFor="comments" className="font-semibold">
      Comments
    </label>
    <Controller
      name="comments"
      control={control}
      render={({ field }) => (
        <InputTextarea
          {...field}
          rows={3}
          autoResize
          className="mt-1 h-16 w-full resize-none rounded border border-slate-200 px-1 text-xs"
          tabIndex={10}
        />
      )}
    />

    <div className="mt-1 flex flex-wrap gap-1">
      {OPU_SEARCH_COMMENT_OPTIONS.map((c) => (
        <Button
          key={c}
          label={c}
          size="small"
          outlined
          type="button"
          className="h-6 px-2 text-[10px]"
          onClick={() => {
            const lines = comments.split('\n');
            const idx = lines.indexOf(c);
            if (idx !== -1) lines.splice(idx, 1);
            else lines.push(c);
            setValue('comments', lines.filter(Boolean).join('\n'));
          }}
        />
      ))}
    </div>
  </section>
);
